// utils
import React from 'react';
import ReactDOM from 'react-dom';
import JS from './JS/index';
// styles
import './index.css';
import './assets/fonts/siconfont';
import './slider.scss';
// tools
// import registerServiceWorker from './registerServiceWorker';
// Router
// import './Router';
import { HomePageStatic } from './pages/HomePageStatic';
import { HomePageFeRender } from './pages/HomePageFeRender';
// import { useUserInfoContext } from './context/useUserInfoContext';

if (!(document.getElementById('root') as HTMLElement ).innerHTML) {
    ReactDOM.render(
        (
            <HomePageStatic />
        ),
        document.getElementById('root') as HTMLElement || document.createElement('div'),
    );
}

ReactDOM.render(
    (
        <HomePageFeRender />
    ),
    document.getElementById('fe-root') as HTMLElement || document.createElement('div'),
);

// 前端处理页面初始化逻辑入口
JS.init();



// WEBPACK FOOTER //
// ./src/index.tsx